<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.practitioners', 1) }} {{ $tc('message.institutions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" v-if="show">
                    <b-form-group
                            id="institution-group"
                            :label="$tc('message.institutions', 1)"
                            label-for="institution"
                    >
                        <select id="institution" v-model="$v.form.etablissement_exercice_id.$model"
                                @change="clearErrorField('etablissement_exercice_id')"
                                required
                                multiple
                        >
                            <option data-placeholder="true"></option>
                            <option value="0">
                                {{ $t('message.addAll') | capitalize}}
                            </option>
                            <option v-for="item in mInstitutions" :key="item.value" :value="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                        <b-form-invalid-feedback>
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                        <span v-if="errorshasField('etablissement_exercice_id')" style="color:red">
                                    {{getErrorsField('etablissement_exercice_id')}}
                                    </span>
                    </b-form-group>

                    <b-button type="submit" class="justify-content-center" variant="primary">
                        {{ $t('message.save') }}
                    </b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from "slim-select";

    export default {
        name: "AddInstitution",
        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString().toUpperCase();
                return value;
            }
        },
        computed: {
            ...mapGetters(["institutions", "errors"]),

            mInstitutions: function() {
                let iArray = [];

                _.forEach(this.institutions, function(institution) {
                    iArray.push({ value: institution.id, text: institution.name });
                });

                return iArray;
            },

            rows: function() {
                return this.mInstitutions.length;
            }
        },

        data() {
            return {
                praticien_id: this.$route.params.praticien,
                form: {
                    etablissement_exercice_id: [],
                },
                show: true
            }
        },

        methods: {
            getInstitutions() {
                this.$store.dispatch('getInstitutions', { args : {} });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        praticien_id: this.praticien_id,
                        etablissement_exercice_id: this.form.etablissement_exercice_id
                    };

                    let successMessage = this.$i18n.t('message.institutionCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createPratitienInstitution', { args, errorMessages, successMessage });
                }
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                etablissement_exercice_id: {
                    required
                }
            }
        },

        mounted() {
            // Fetch institution list
            this.getInstitutions();

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit:5
            });
        }
    }
</script>

<style scoped>

</style>